module.exports = __webpack_public_path__ + "static/launch_readiness@2x-96b1f9d48aef7246f1beeb817a84d925.png";